import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import {numeralFormat} from '../common/numeralFormat';
// import { dataDummy } from './data';

const ACTIONS_TEAM = {
    GET_INFO_BATTERS_GAMES_SUCCESS: 'GET_INFO_BATTERS_GAMES_SUCCESS',
    GET_INFO_BATTERS_GAMES_ERROR: 'GET_INFO_BATTERS_GAMES_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getListTeamBatters = (id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // team_id
    let url = `${host.serverTest}api/teams/${id}/batters`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS_TEAM.GET_INFO_BATTERS_GAMES_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_TEAM.GET_INFO_BATTERS_GAMES_ERROR, err));
            });
    };

};

const converDataBatters = (list) => {
    if (list) {
        const arr = list.map(value => {
            return {
                id: value.id,
                item: [
                    { text: value.uniform_number },//背番号
                    { text: value.player_name },//選手
                    { text: value.g },//試合
                    { text: value.pa },//打席
                    { text: value.ab },//打数
                    { text: value.r },//得点
                    { text: value.h },//安打
                    { text: value.h2b },//二塁打
                    { text: value.h3b },//三塁打
                    { text: value.hr },//本塁打
                    { text: value.tb },//塁打
                    { text: value.rbi },//打点
                    { text: value.so },//三振
                    { text: value.bb },//四球
                    { text: value.ibb },//敬遠
                    { text: value.hbp },//死球
                    { text: value.sh },//犠打
                    { text: value.sf },//犠飛
                    { text: value.sb },//盗塁
                    { text: value.cs },//盗塁刺
                    { text: value.gidp },//併殺打
                    { text: value.e },//失策
                    { text: value.avg ? numeralFormat(value.avg, 3) : value.avg },//打率
                    { text: value.slg ? numeralFormat(value.slg, 3) : value.slg},//長打率
                    { text: value.obp ? numeralFormat(value.obp, 3) : value.obp},//出塁率
                    { text: value.ops ? numeralFormat(value.ops, 3) : value.ops},//OPS
                    { text: value.comback_date },//1軍復帰
                    { is_reached_num: value.is_reached_num}
                ]
            }
        });
        return arr;
    }
}

export {
    ACTIONS_TEAM, getListTeamBatters, converDataBatters
};
